module.exports = __webpack_public_path__ + "static/media/fly_flying_spritesheet.cde08e82.png";